<template>
  <div class="wave-list">
    <div class="scroll-y scroll-on-hover">
      <div class="wave-items">
        <WaveCard v-for="wave in waveData.SurveyWave"
                  :key="wave.Id"
                  :wave="wave"
                  @click="$emit('wave-click', wave)" />
      </div>
    </div>
  </div>
</template>

<script>
import WaveCard from './WaveCard.vue';

export default {
  name: 'WaveList',

  components: {
    WaveCard
  },

  props: {
    waveData: {
      type: Object,
      required: true
    }
  },

  emits: ['wave-click']
}
</script>

<style lang="scss" scoped>
.wave-list {
  position: relative;
}

.wave-items {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
</style>
